import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useWebinarSlot } from '../components/useWebinarSlot';
const shakeAnimation = {
  rotate: [0, -2.5, 2.5, -2, 2, -1, 1, 0],
  scale: [1, 1.02, 1.02, 1.01, 1.01, 1, 1, 1]
};
const shakeTransition = {
  duration: 0.7,
  ease: 'easeInOut' as const,
  repeat: Infinity,
  repeatDelay: 4,
  times: [0, 0.15, 0.3, 0.45, 0.6, 0.75, 0.9, 1]
};
const OPTIN_URL = '/webinar-mc-stem-meta';
const CTA_DELAY_MS = 15000;
export const VidStemMetaPage = () => {
  const [showCTA, setShowCTA] = useState(false);
  const slot = useWebinarSlot();
  useEffect(() => {
    const timer = setTimeout(() => setShowCTA(true), CTA_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);
  return <>
      <div className="advertorial-content max-w-3xl mx-auto px-4 font-sans text-gray-800 pb-32 md:pb-12" data-id="element-4394" data-mp="23qho5a719zd3">
        {/* Logo */}
        <div className="pt-6 pb-4 px-4 max-w-3xl mx-auto" data-id="element-4395" data-mp="9et3qsi194lb">
          <div className="flex items-center justify-center mb-2" data-id="element-4396" data-mp="9ge0mortkzmc">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs Logo" className="h-14 object-contain" data-id="element-4397" data-mp="1x6jnj8ij5d27" />
          </div>
        </div>

        {/* HOOFDTITEL + VIDEO */}
        <section className="mb-10 text-center" data-id="element-4398" data-mp="2bvpk0opzgp6e">
          <h1 className="text-xl md:text-3xl font-bold text-[rgb(30,64,175)] mb-3 md:mb-6 text-center leading-tight md:leading-snug" data-id="element-4399" data-mp="2gthloagfjpns">
            Waarom jouw hond niet luistert - en waarom jij daar zelf de oorzaak
            van bent
          </h1>
          <p className="text-sm md:text-base text-blue-600 font-semibold mb-4 md:mb-8 text-center leading-snug" data-id="element-4400" data-mp="2puflegju5b0k">
            Modern onderzoek naar honden laat zien dat we op een andere manier
            met hen om moeten gaan.
          </p>

          {/* Vimeo video - square op mobiel, 16:9 op desktop */}
          <div className="w-full mb-2 rounded-lg overflow-hidden bg-black" data-id="element-4401" data-mp="10f7wje4d5wvw">
            <div className="relative w-full aspect-square md:aspect-video" data-id="element-4402" data-mp="sf1og4n0kz64">
              <iframe src="https://player.vimeo.com/video/1193612743?badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1&muted=1&playsinline=1" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" className="absolute top-0 left-0 w-full h-full" title="Stressless Dogs - Stem video" frameBorder="0" data-id="element-4403" data-mp="odgh0yt91d3b"></iframe>
            </div>
          </div>
          <p className="text-xs text-gray-400 italic mb-6" data-id="element-4404" data-mp="1l2xsxvitrvdg">
            Bekijk video: Amee legt uit waarom je stem gebruiken zelfs de minst
            effectieve manier is om met je hond te communiceren.
          </p>

          {/* Desktop CTA - los onder de video, verschijnt na 15s */}
          <AnimatePresence data-id="element-4405" data-mp="1uyr1l3tfb4py">
            {showCTA && <motion.div key="desktop-cta" initial={{
            opacity: 0,
            y: 12
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            ease: 'easeOut'
          }} className="hidden md:block mt-8 mb-4" data-id="element-4406" data-mp="1q3bqukqppoxr">
                <p className="text-sm text-gray-700 mb-3" data-id="element-4407" data-mp="1pzutkqxy2t9k">
                  {slot.dateLabel} • {slot.time}
                </p>
                <motion.a href={OPTIN_URL} animate={shakeAnimation} transition={shakeTransition} whileHover={{
              scale: 1.03
            }} whileTap={{
              scale: 0.98
            }} className="block w-full max-w-xl mx-auto bg-green-500 hover:bg-green-600 text-white font-bold py-4 px-6 rounded-lg transition-colors text-base shadow-lg text-center" data-id="element-4408" data-mp="1uqtczze8c7h1">
                  GRATIS MASTERCLASS: Communiceren Met Je Hond
                </motion.a>
              </motion.div>}
          </AnimatePresence>
        </section>
      </div>

      {/* Sticky bar alleen op mobiel - verschijnt na 15s */}
      <AnimatePresence data-id="element-4409" data-mp="20m32youvolsi">
        {showCTA && <motion.div key="mobile-sticky" initial={{
        opacity: 0,
        y: 60
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 60
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white shadow-[0_-2px_10px_rgba(0,0,0,0.1)]" data-id="element-4410" data-mp="20la387uc6wjv">
            <div className="max-w-3xl mx-auto px-4 py-2 text-center" data-id="element-4411" data-mp="3gy8mmyted7i0">
              <p className="text-sm text-gray-700 mb-2" data-id="element-4412" data-mp="3c2jisjach4fw">
                {slot.dateLabel} • {slot.time}
              </p>
              <motion.a href={OPTIN_URL} animate={shakeAnimation} transition={shakeTransition} whileTap={{
            scale: 0.98
          }} className="block w-full bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-lg transition-colors text-base text-center" data-id="element-4413" data-mp="3jiokv6a39ra2">
                GRATIS MASTERCLASS: Communiceren Met Je Hond
              </motion.a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
};